import { isVideo, resizeCloudinary } from "../../../utils/util";

type LoopPreviewProps = {
  loopUrl: string;
  alt: string;
  size?: 48 | 96 | 150 | 200;
};

const LoopPreview = ({ loopUrl, alt, size = 48 }: LoopPreviewProps) => {
  return isVideo(loopUrl) === "image" ? (
    <img
      loading="lazy"
      alt={alt}
      src={resizeCloudinary(loopUrl, size)}
      style={{
        width: "auto",
        height: "100%",
        objectFit: "cover",
      }}
    />
  ) : (
    <video
      muted={true}
      src={resizeCloudinary(loopUrl, size)}
      loop
      autoPlay
      style={{
        width: "auto",
        height: "100%",
        objectFit: "cover",
      }}
    />
  );
};

export default LoopPreview;
